<div class="toast">
  <div class="left-border" [ngStyle]="{ background: color }"></div>

  <div class="content">
    <wchfs-icon class="icon" size="24" [svgIcon]="icon"></wchfs-icon>

    <div class="message">
      {{ message }}
    </div>
  </div>

  <wchfs-icon class="close" size="24" svgIcon="pso:close_m" (click)="close()"></wchfs-icon>
</div>
